import React, { useRef } from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { greetingTitleStyles } from 'lib/typography/greeting-title-styles'
import ClubDashboardHeaderActions from './club-dashboard-header-actions'

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(3),
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    width: '100%',
    minWidth: 0,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  titleBlock: {
    flex: '1 1 auto',
    minWidth: 0,
    maxWidth: 520,
  },
  greeting: {
    display: 'block',
    marginBottom: theme.spacing(1),
    ...greetingTitleStyles(theme),
  },
  subtitle: {
    display: 'block',
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    lineHeight: 1.5,
    maxWidth: 480,
  },
}))

const ClubDashboardHeader = ({ greetingTitle, onBookClick, messagesPath }) => {
  const classes = useStyles()
  const headerRowRef = useRef(null)
  const titleBlockRef = useRef(null)

  return (
    <Box className={classes.root}>
      <Box ref={headerRowRef} className={classes.headerRow}>
        <Box ref={titleBlockRef} className={classes.titleBlock}>
          <Typography component="h1" className={classes.greeting}>
            {greetingTitle}
          </Typography>
          <Typography component="p" className={classes.subtitle}>
            Keep your game moving forward.
          </Typography>
        </Box>
        <ClubDashboardHeaderActions
          onBookClick={onBookClick}
          messagesPath={messagesPath}
          headerRowRef={headerRowRef}
          titleBlockRef={titleBlockRef}
        />
      </Box>
    </Box>
  )
}

export default ClubDashboardHeader
